export class Signature {
    private isDrawing: boolean = false;
    private lastX: number = 0;
    private lastY: number = 0;
    private hasDrawn: boolean = false;

    public init(canvasId: string): void {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        if (!canvas) {
            console.error(`Canvas with id '${canvasId}' not found`);
            return;
        }
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            console.error("2D context not supported on this canvas");
            return;
        }
        // Mouse events
        canvas.addEventListener('mousedown', (e: MouseEvent) => {
            this.isDrawing = true;
            const rect = canvas.getBoundingClientRect();
            this.lastX = e.clientX - rect.left;
            this.lastY = e.clientY - rect.top;
        });
        canvas.addEventListener('mousemove', (e: MouseEvent) => {
            if (!this.isDrawing) return;
            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            this.hasDrawn = true;
            ctx.beginPath();
            ctx.moveTo(this.lastX, this.lastY);
            ctx.lineTo(x, y);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.closePath();
            this.lastX = x;
            this.lastY = y;
        });
        canvas.addEventListener('mouseup', () => {
            this.isDrawing = false;
        });
        canvas.addEventListener('mouseout', () => {
            this.isDrawing = false;
        });
        // Touch events
        canvas.addEventListener('touchstart', (e: TouchEvent) => {
            e.preventDefault();
            const rect = canvas.getBoundingClientRect();
            this.isDrawing = true;
            this.lastX = e.touches[0].clientX - rect.left;
            this.lastY = e.touches[0].clientY - rect.top;
        });
        canvas.addEventListener('touchmove', (e: TouchEvent) => {
            e.preventDefault();
            if (!this.isDrawing) return;
            this.hasDrawn = true;
            const rect = canvas.getBoundingClientRect();
            const x = e.touches[0].clientX - rect.left;
            const y = e.touches[0].clientY - rect.top;
            ctx.beginPath();
            ctx.moveTo(this.lastX, this.lastY);
            ctx.lineTo(x, y);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.closePath();
            this.lastX = x;
            this.lastY = y;
        });
        canvas.addEventListener('touchend', () => {
            this.isDrawing = false;
        });
    }

    public clearCanvas(canvasId: string): void {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.hasDrawn = false;
    }

    public getSignature(canvasId: string): string {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        if (!canvas) throw Error("Canvas not found");
        return canvas.toDataURL("image/png"); // Base64 string
    }

    public isDrawn(): boolean {
        return this.hasDrawn;
    }
}

(<any>window)['Signature'] = new Signature();
